import _extends from "@swc/helpers/src/_extends.mjs";
// DS: i3.16
import React from 'react';
import IconWrap from '../../IconWrap';
const Trashcan = (props)=>/*#__PURE__*/ React.createElement(IconWrap, _extends({}, props), /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M14 3a1 1 0 011 1v1h5a1 1 0 010 2h-1v11.586a1 1 0 01-.293.707l-1.414 1.414a1 1 0 01-.707.293H7.414a1 1 0 01-.707-.293l-1.414-1.414A1 1 0 015 18.586V7H4a1 1 0 110-2h5V4a1 1 0 011-1h4zm3 4H7v11.171l.829.829h8.341l.83-.83V7zm-7 3a1 1 0 011 1v5a1 1 0 01-2 0v-5a1 1 0 011-1zm4 0a1 1 0 011 1v5a1 1 0 01-2 0v-5a1 1 0 011-1z"
    })));
Trashcan.displayName = 'Trashcan';
export default Trashcan;
